export default __webpack_public_path__ + "static/media/appLogo3.3dc59dc5.png";